import {transactionsReducerKey} from './types';
import {State} from '../reducer';
import {createSelector} from 'reselect';
import {IStatesResponse} from 'types/StatesResponse';
import {every} from 'lodash';
import {enums} from 'types/enums';

const areAnyTransactionsSuspendedDirectly = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) =>
      states.anyOutboundTransactionsSuspendedDirectly ||
      states.anyInboundTransactionsSuspendedDirectly ||
      states.anySynchronizationsSuspendedDirectly
);

const areAllTransactionsSuspendedDirectly = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) =>
      every(states.statesMap, (ob: any) => ob.typeId === enums.State.DIRECTLY_SUSPENDED)
);

const isTransactionFolderSuspended = createSelector(
   (state: State) => state.layout.states,
   (states) => states.foldersMap?.Transactions?.typeId === enums.State.SUSPENDED
);

const isInboundTransactionFolderSuspended = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) => states.foldersMap?.Inbound?.typeId === enums.State.SUSPENDED
);

const isOutboundTransactionFolderSuspended = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) => states.foldersMap?.Outbound?.typeId === enums.State.SUSPENDED
);

const areTransactionsSuspendedDueToAuditFailure = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) => states.auditFailure
);

const areTransactionsSuspendedDueToDbRestore = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) => states.dbRestore
);

const currentTransactionId = (state: State) => state.commonPage.data.id; // state.transactions.panel.transactionId.values?.id;
const currentTransactionName = (state: State) => state.commonPage.data.name;
const isSubmitting = (state: State) => state.transactions.isSubmitting;

export default {
   isFetching: (state: State) => state[transactionsReducerKey].isFetching,
   areAnyTransactionsSuspendedDirectly,
   isTransactionFolderSuspended,
   isInboundTransactionFolderSuspended,
   isOutboundTransactionFolderSuspended,
   areTransactionsSuspendedDueToAuditFailure,
   areTransactionsSuspendedDueToDbRestore,
   areAllTransactionsSuspendedDirectly,

   isSubmitting,
   currentTransactionId,
   currentTransactionName,
};
